import { useState, useEffect, useCallback } from 'react';
import { getUserCompanyByCompany } from '../../../data/company/repositories/companyMasterRepository';
import { useLoader, useStore } from '../../../common/hooks';
import { MultiValue, SingleValue } from 'react-select';
import { F1PasswordManagement, GetF1PasswordManagementRequest, UpdateF1PasswordManagementRequest } from 'models/config/F1PasswordManagement';
import Swal from 'sweetalert2';
import F1PasswordManagementStore from '../../../store/domain/F1PasswordManagement.store';

type SystemType = 'UAT' | 'PRE-PRD' | 'PRD';

interface Option {
    readonly label: string;
    readonly value: string;
}

function PasswordManagemntViewModel() {
    const loader = useLoader();
    const [companyOptions, setCompanyOptions] = useState<Option[]>([]);
    const [company, setCompany] = useState<Option | null>(null);
    const [f1PasswordManagement, setF1PasswordManagement] = useState<F1PasswordManagement>();
    const { companyMasterStore, userCompanyStore, f1PasswordManagementStore } = useStore();
    const companyMaster = companyMasterStore.companyMaster;
    const [selectedSystemType, setSelectedSystemType] = useState<SystemType>();
    const { currentAdminCompany, userRole } = userCompanyStore;

    const onSelectCompany = (company: SingleValue<Option>) => {
        setCompany(company);
    };

    useEffect(() => {
        const companySelectOption: Option[] = [];
        if (companyMaster) {
            companyMaster.forEach(company => {
                companySelectOption.push({
                    label: company.company_name,
                    value: company.sid
                } as Option);
            });

            setCompanyOptions(companySelectOption);
        }
    }, [companyMaster]);

    useEffect(() => {
        if (userRole === '' || userRole === 'User' || currentAdminCompany.length === 0) {
            return;
        }

        //if (currentAdminCompany && currentAdminCompany.length > 0) {
        var companyArray: Option[] = [];
        currentAdminCompany.forEach(item => {
            //if (citizenId == item.citizen_id && (item.type === 'admin' || item.type === 'super_admin')) {
            companyArray.push({
                label: item.company_name,
                value: item.sid
            } as Option);
            //}
        });
        const company = companyArray[0];

        //console.log(selectedCompany)

        if (userRole === 'Admin') {
            setCompanyOptions(companyArray);
            onSelectCompany(company);
        }

    }, [userRole, currentAdminCompany]);

    //useEffect(() => {
    //    console.log(f1PasswordManagement?.MINIMUMPWD)
    //    console.log(f1PasswordManagement?.LOGINFAILTIME)

    //}, [f1PasswordManagement]);

    const onCheckSystemType = (systemType: 'UAT' | 'PRE-PRD' | 'PRD') => {
        setSelectedSystemType(systemType);
    };

    const handleSearch = async () => {
        try {
            loader.show();

            if (!company?.value) {
                Swal.fire({
                    title: 'Error!',
                    text: 'กรุณาเลือก Company',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Yes',
                    allowOutsideClick: false
                });

                return;
            }

            if (!selectedSystemType) {
                Swal.fire({
                    title: 'Error!',
                    text: 'กรุณาเลือก System Type',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Yes',
                    allowOutsideClick: false
                });

                return;
            }

            const searchF1PasswordManagement: GetF1PasswordManagementRequest = {
                sid: company?.value,
                systemType: selectedSystemType,
            };

            await f1PasswordManagementStore.fetchF1PasswordManagement(searchF1PasswordManagement);
            const f1PassswordManagementData = f1PasswordManagementStore.f1PassswordManagement;

            setF1PasswordManagement(f1PassswordManagementData[0]);
        } catch (error) {
            console.log(error);
            if (error instanceof Error) {
                fireSwal('Error!', error.message, 'error');
            } else {
                fireSwal('Error!', (error as Error).message, 'error');
            }
        } finally {
            loader.hide();
        }
    };

    const handleChange = (key: string, value: string) => {
        setF1PasswordManagement(prevState => {
            if (!prevState) return undefined;

            return {
                ...prevState,
                [key]: value
            };
        });
    };

    const handleEdit = async () => {
        try {
            loader.show();

            var validData = validationData();
            console.log(validData)
            if (validData) {
                console.log(validData)
                throw new Error(validData);
            }

            const updateF1PasswordManagement: UpdateF1PasswordManagementRequest = {
                sonar_sid: company?.value,
                system_type: selectedSystemType,
                SID: f1PasswordManagement?.SID,
                PWDEXPPERIOD: f1PasswordManagement?.PWDEXPPERIOD,
                MINIMUMPWD: f1PasswordManagement?.MINIMUMPWD,
                LOGINFAILTIME: f1PasswordManagement?.LOGINFAILTIME,
                AUTOINACTIVE: f1PasswordManagement?.AUTOINACTIVE,
                PWDLENGTH: f1PasswordManagement?.PWDLENGTH,
                WARNINGEXPPWD: f1PasswordManagement?.WARNINGEXPPWD,
                RequireCharacterLower: f1PasswordManagement?.RequireCharacterLower,
                RequireCharacterUpper: f1PasswordManagement?.RequireCharacterUpper,
                RequireNumber: f1PasswordManagement?.RequireNumber,
                RequireSpecialCharacter: f1PasswordManagement?.RequireSpecialCharacter,
                ResetPasswordDelay: f1PasswordManagement?.ResetPasswordDelay,
                PasswordHistory: f1PasswordManagement?.PasswordHistory,
            };

            await f1PasswordManagementStore.updateF1PasswordManagement(updateF1PasswordManagement);

            fireSwal('Success!', 'Update Password Configuration success.', 'success');

            await handleSearch();
        } catch (error) {
            if (error instanceof Error) {
                fireSwal('Error!', error.message, 'error');
            }
        } finally {
            loader.hide();
        }
    };

    const validationData = () => {
        if (!f1PasswordManagement) {
            //fireSwal('Error!', "ไม่พบข้อมูลที่ต้องการแก้ไข", 'error');

            return "ไม่พบข้อมูลที่ต้องการแก้ไข";
        }

        const f1PasswordManagementPropNames = Object.keys(f1PasswordManagement)
        for (const propName of f1PasswordManagementPropNames) {
            console.log((f1PasswordManagement[propName]).toString())
            
            if ((f1PasswordManagement[propName]).toString().trim().length === 0) {
                //fireSwal('Error!', "ข้อมูลที่ต้องการแก้ไขไม่ถูกต้อง", 'error');
                console.log((f1PasswordManagement[propName]).toString().trim().length)

                return "พบค่าว่างในข้อมูลที่ต้องการแก้ไข";
            }
        };

        return undefined;
    };

    const fireSwal = useCallback(
        (title: string, message: string, icon: Parameters<typeof Swal.fire>[2]) => {
            return Swal.fire({
                title,
                text: message,
                icon,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Yes',
                allowOutsideClick: false
            });
        },
        []
    );

    return {
        f1PasswordManagement,
        currentAdminCompany,
        companyOptions,
        userRole,
        company,
        onSelectCompany,
        onCheckSystemType,
        handleSearch,
        handleEdit,
        handleChange,
        fireSwal,
    };
}

export default PasswordManagemntViewModel;